export const colors = {
  main: '#19242B',
  primary: '#EEEEE4',
  second: '#494949',
  third: '#8A8A8A',
  fourth: '#D3D3D3',
  red: '#FF4444'
}
